import {
  FilterForm,
  FilterButton,
  SearchInput,
  SelectInput,
  useListContext
} from 'react-admin';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { SearchFacet } from '@src/types';

// Apply styles to the FilterButton so it looks/behaves like other buttons
// This is more for future style alignment if we decide to use ExportButton for example
const StyledFilterButton = styled(FilterButton)({
  display: 'inline-flex',
  alignItems: 'center',
  '& .MuiButton-root': {
    width: '100%',
    height: '100%',
    padding: '0 16px'
  },
});

// Component that renders filters with access to list context
const CatalogListToolbar = () => {
  const { meta } = useListContext();
  // Assertion here to handle React Admin's generic approach to dataProviders
  const searchFacets = (meta?.filters as SearchFacet[] | undefined) || [];

  const inputs = [
    <SearchInput key="search" source="searchQuery" placeholder="Search catalog..." alwaysOn />,
  ];

  // Add dynamic facet filters
  searchFacets.forEach((facet: SearchFacet) => {
    const choices = facet.entries?.map(entry => ({
      id: entry.name,
      name: entry.name,
    })) || [];

    inputs.push(
      <SelectInput
        key={facet.tag}
        source={facet.tag}
        choices={choices}
        placeholder={facet.title || facet.tag}
        resettable
        sx={{ width: '150px' }}
      />
    );
  });

  return (
    <Stack direction="row" sx={{ mb: 2 }}>
      <FilterForm filters={inputs} />
      <StyledFilterButton filters={inputs} />
    </Stack>
  );
};

export default CatalogListToolbar;
